import { SCORE_CONFIG } from './scoreConfig';

export const calculateSaveRate = (streams: number, saves: number): number => {
  if (streams === 0) return 0;
  return Math.round((saves / streams) * 10000) / 100; // Prozentwert mit 2 Nachkommastellen
};

const cappedLog = (value: number, max: number) =>
  Math.min(Math.log10(value + 1) / Math.log10(max + 1), 1);

export const calculateScore = (
  streams: number,
  listeners: number,
  saves: number,
  playlists: number
): number => {
  const saveRate = calculateSaveRate(streams, saves);

  // LINEAR behandelt:
  const streamScore = Math.min(streams / SCORE_CONFIG.streams.scale, 1) * SCORE_CONFIG.streams.weight;
  const listenerScore = Math.min(listeners / SCORE_CONFIG.listeners.scale, 1) * SCORE_CONFIG.listeners.weight;

  // LOGARITHMISCH behandelt:
  const saveScore = cappedLog(saves, SCORE_CONFIG.saves.scale) * SCORE_CONFIG.saves.weight;
  const playlistScore = cappedLog(playlists, SCORE_CONFIG.playlists.scale) * SCORE_CONFIG.playlists.weight;

  const saveRateScore = Math.min(saveRate / SCORE_CONFIG.saveRate.scale, 1) * SCORE_CONFIG.saveRate.weight;

  // Gewichtung korrekt auf 1.0 normieren
  const total = streamScore + listenerScore + saveScore + playlistScore + saveRateScore;

  const totalWeight =
    SCORE_CONFIG.streams.weight +
    SCORE_CONFIG.listeners.weight +
    SCORE_CONFIG.saves.weight +
    SCORE_CONFIG.playlists.weight +
    SCORE_CONFIG.saveRate.weight;

  const normalized = Math.pow(total / totalWeight, 1.4) * 100;

  return Math.round(normalized * 100) / 100;
};
